"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function UploadSwitchDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/upload-switch.html',
        controller: /** @class */ (function (_super) {
            __extends(UploadSwitchController, _super);
            function UploadSwitchController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.label = $scope.option.label;
                _this.form.value = book.getIndex(_this.prefix, _this.id);
                _this.onChange();
                return _this;
            }
            UploadSwitchController.prototype.onChange = function () {
                var index = this.form.value;
                this.book.update(this.prefix, this.id, index);
            };
            return UploadSwitchController;
        }(form_1.FormOptionController)),
        controllerAs: 'uploadSwitchCtrl'
    };
}
exports.UploadSwitchDirective = UploadSwitchDirective;
